// Import necessary libraries and components
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import dateIcon from '../images/icons/calendar.png';
import ClockIcon from '../images/icons/clock.webp';
import { Link } from 'gatsby';


// Function to truncate text
function truncateText(text, maxLength) {
    if (!text) return ''; // Return empty string if text is null or undefined
    const plainText = documentToPlainTextString(JSON.parse(text)); // Convert rich text to plain text
    if (plainText.length <= maxLength) return plainText;

    let trimmedText = plainText.substr(0, maxLength + 1); // Cut the text at the maximum length +1
    trimmedText = trimmedText.substr(0, Math.min(trimmedText.length, trimmedText.lastIndexOf(" "))); // Find the last space and cut off there
    return trimmedText + '...'; // Add ellipsis
}

// WebinarSpotlight component
const WebinarSpotlight = () => {
    // GraphQL query to fetch data for the WebinarSpotlight section
    const data = useStaticQuery(graphql`
        query staticUsersshanefelthamDesktopGatsbyHolbornSpainsrccomponentswebinarSpotlightJs1626251309 {
  allContentfulWebinars(sort: {webinarDate: DESC}, limit: 3) {
    edges {
      node {
        id
        slug
        webinarTitle
        aboutTheWebinar {
          raw
        }
        webinarDate(formatString: "MM/DD/YYYY")
        webinarLength
        headerImage {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  }
}
    `);

    // Extracting webinar data
    const webinars = data.allContentfulWebinars.edges;

    // Render WebinarSpotlight component
    return (
        <div className="section webinar-spotlight w-full bg-white">
            <div className="grid grid-cols-12 w-full h-full relative py-14">
                <div className="col-span-12 lg:col-start-3 lg:col-span-8">
                    <h2 className="pb-10 text-center">Webinar Spotlight</h2>
                    <div className="grid grid-cols-12 lg:gap-10 gap-y-6 p-6">
                        {webinars.map(({ node: webinar }) => {
                            const webinarDate = new Date(webinar.webinarDate); // Convert webinar date to a Date object
                            const now = new Date(); // Get the current date
                            const isPastWebinar = webinarDate < now; // Check if the webinar is past

                            return (
                                <div key={webinar.id} className="col-span-12 lg:col-span-4">
                                    <div className='flex flex-col h-full border-2'>
                                        <div className='webinar-image-wrapper'>
                                            <Link to={`/webinar/${webinar.slug}`}>
                                                {webinar.headerImage && (
                                                    <GatsbyImage image={getImage(webinar.headerImage)} alt={webinar.webinarTitle} />
                                                )}
                                            </Link>
                                        </div>
                                        <div className='flex flex-col justify-between flex-grow p-6 border-t-2'>
                                            <div>
                                                <div className='flex items-center mb-4'>
                                                    <img
                                                        src={dateIcon}
                                                        alt="Calendar Icon"
                                                        className="inline-block mr-2"
                                                        style={{ width: '25px', height: '25px' }}
                                                    />
                                                    <p className='p-0'>{webinar.webinarDate}</p>
                                                </div>
                                                <a href={`/webinar/${webinar.slug}`}>
                                                    <h6 className="font-bold">{webinar.webinarTitle}</h6>
                                                </a>
                                                <p>{truncateText(webinar.aboutTheWebinar.raw, 100)}</p>
                                            </div>
                                            <div className='button-wrapper flex justify-between items-center'>
                                                <a className='text-holborn-green font-bold' href={`/webinar/${webinar.slug}`}>
                                                    {isPastWebinar ? 'Watch the webinar' : 'Book your spot'}
                                                </a>
                                                {isPastWebinar && webinar.webinarLength && (
                                                    <div className='text-right'>
                                                        <img
                                                            src={ClockIcon}
                                                            alt="Clock Icon"
                                                            className="inline-block mr-2"
                                                            style={{ width: '25px', height: '25px' }}
                                                        />
                                                        <span>{`${webinar.webinarLength} min`}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WebinarSpotlight;
